/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{c as r}from"../../chunks/vec3f64.js";import{projectBuffer as e}from"./projectBuffer.js";function o(r,o,c){return e(r,o,0,t,c.spatialReference,0,1)?(c.x=t[0],c.y=t[1],c.z=t[2],c):null}const t=r();export{o as projectVectorToDehydratedPoint};
